import React, { useContext } from "react";
import { QuizContext } from "../../App";
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';

const TableTeamInvited = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <>
      {!quizContext.state.invited.length
        ? <div style={{ color: "red" }}>Приглашёных пока нет</div>
        : <Table
          striped hover
          variant={theme}
          style={{
            width: "100%",
            maxHeight: "400px",
            overflowX: "hidden",
          }}
        >
          <tbody>
            {quizContext.state.invited
              .filter((el) => quizContext.state.searchItem.toLowerCase() === ""
                ? el
                : el.username.toLowerCase().includes(quizContext.state.searchItem.toLowerCase()))
              .map((el, i) => (

                <tr key={i}>
                  <th style={{ textAlign: "left" }}>
                    <Link
                      to={`/user/${el.user_id}`}
                      style={{ textDecoration: "none" }}
                    >
                      <button
                        className={`${theme}-link-btn`}
                        onClick={() => quizContext.dispatch({
                          type: "backToMainPage"
                        })}
                      >
                        {el.username}
                      </button>
                    </Link>
                  </th>
                  <th style={{ textAlign: "right", fontWeight: "500" }}>
                    <span>приглашён</span>
                  </th>
                </tr>
              ))}
          </tbody>
        </Table>
      }
    </>
  )
}

export default TableTeamInvited